import { useEffect, useState } from "react"
import apis from "../../../api"
import { apiResult, getUserSession, minuteToTime, } from "../../../Utils/Common"
import { WeekDays } from "../../../Utils/Dict"
import { Avatar, Box, IconButton, ListItemButton, ListItemText, ListSubheader, Tooltip, Typography } from "@mui/material"
import { getItemsFromObjects } from "../../../Component/DataLoader"
// import { CoachLoader } from "../../fragement/CoachSelector"
import { Add, Done, DoNotDisturb, EditOutlined, GroupOutlined, HouseOutlined, PersonOutline, } from "@mui/icons-material"
import { RightDrawer } from "../../../Component/MuiEx"


const ClassList = (props) => {
    const { category_id, onError, onClick, classList, classRooms, coaches, onEdit } = props
    const [classes, setClasses] = useState()
    const [rightDrawer, setRightDrawer] = useState()
    const [autoCloseRightDraw, setAutoCloseRightDraw] = useState(true)
    const [curIdx1, setIdx1] = useState()
    const [curIdx2, setIdx2] = useState()
    const [clickClass, setClickClass] = useState()
    getUserSession(apis)

    useEffect(() => {
        setIdx1()
        setIdx2()
        setClickClass()
        setClasses(classList)
    }, [classList])

    const handleClassClick = (idx1, idx2, item) => {
        if (item.id == clickClass?.id) {
            setClickClass()
            onClick && onClick()
        } else {
            onClick && onClick(item)
            setClickClass(item)
        }
    }
    const handleExpand = (idx) => {
        let cc = [...classes]
        cc[idx].expand = !cc[idx].expand
        setClasses(cc)
    }

    const handleEdit = (idx1, idx2) => {
        onEdit && onEdit(classes[idx1].classes[idx2])
    }
    const handleAdd = (idx) => {
        onEdit && onEdit({ id: 0, category_id, week_date: classes[idx].week_date })
    }
    const handleRightDrawer = () => {
        if (autoCloseRightDraw)
            setRightDrawer(false)
    }
    const handleDelete = (idx1, idx2) => {
        apis.classDelete(classes[idx1].classes[idx2].id).then(ret => {
            apiResult(ret, data => {
                let cc = [...classes]
                cc[idx1].classes[idx2].status = 0
                setClasses(cc)
            }, onError)
        })
    }
    const handleEnable = (idx1, idx2) => {
        apis.classPut({ id: classes[idx1].classes[idx2].id, status: 1 }).then(ret => {
            apiResult(ret, data => {
                let cc = [...classes]
                cc[idx1].classes[idx2].status = 1
                setClasses(cc)
            }, onError)
        })
    }
    const handleMouseOver = (idx1, idx2) => {
        setIdx1(idx1)
        setIdx2(idx2)
    }
    return <Box sx={{ ...props.sx, bgcolor: "#8881" }}>
        {classes && classes.map((category, idx1) => {
            return <Box key={idx1} >
                <ListSubheader component="div" onMouseEnter={() => handleMouseOver(idx1, -1)}>
                    <Box sx={{ display: "flex", pt: 1, pb: 1, cursor: "pointer" }} onClick={() => handleExpand(idx1)}>
                        <Avatar sx={{ height: 30, width: 30, mr: 1 }}>{WeekDays[category.week_date].substring(0, 1)}</Avatar>
                        <Typography sx={{ mt: 0.6 }}>{WeekDays[category.week_date]} ({category.classes.length})</Typography>
                        <Typography sx={{ flex: '1 1 30%' }} variant="h6" component="div" ></Typography>
                        {/* {idx1 == curIdx1 && curIdx2 == -1 && <> */}
                        <IconButton size="small" onClick={(e) => { e.preventDefault(); handleAdd(idx1) }}><Add /></IconButton>
                        {/* <IconButton size="small" onClick={() => { handleExpand(idx1) }}>{category.expand ? <ExpandMore /> : <ChevronRight />}</IconButton> */}
                        {/* </>} */}
                    </Box></ListSubheader>
                {category.expand && category.classes.map((cls, idx2) => {
                    return <ListItemButton onMouseEnter={() => { handleMouseOver(idx1, idx2) }} key={idx2} selected={clickClass?.id == cls.id} onClick={() => { handleClassClick(idx1, idx2, cls) }}>
                        {coaches && coaches && <ListItemText primary={<Box sx={{ display: "flex" }}>
                            <Tooltip title={cls.status == 1 ? "Active" : "Disabled"}><IconButton aria-label={cls.status == 1 ? "delete" : "enable"} size="small" onClick={() => { cls.status == 1 ? handleDelete(idx1, idx2) : handleEnable(idx1, idx2) }}>{cls.status == 1 ? <Done fontSize="inherit" /> : <DoNotDisturb fontSize="inherit" />}</IconButton></Tooltip>
                            <Typography sx={{ mt: 0.3 }}>{minuteToTime(cls.begin_time) + " - " + minuteToTime(cls.end_time) + " (" + cls.name + ")"}</Typography>
                        </Box>}
                            secondary={<Box sx={{ display: "flex", mt: 0.5, ml: 3, color: idx1 == curIdx1 && idx2 == curIdx2 ? "" : "#8888" }}>
                                <Tooltip title="Classroom"><HouseOutlined fontSize="small" /></Tooltip>
                                <Typography sx={{ ml: 0.5, mr: 2 }}>{getItemsFromObjects(classRooms, cls.room_id)?.name}</Typography>
                                <Tooltip title="Teacher"><PersonOutline fontSize="small" /></Tooltip>
                                <Typography sx={{ ml: 0.5, mr: 2 }}> {getItemsFromObjects(coaches, cls.teacher_id)?.name}</Typography>
                                <Tooltip title="Students"><GroupOutlined fontSize="small" /></Tooltip>
                                <Typography sx={{ ml: 0.5, mr: 2 }}>{cls.students}</Typography>
                            </Box>}
                        />}
                        {idx1 == curIdx1 && idx2 == curIdx2 && <>
                            <Tooltip title="Edit class"><IconButton size="small" onClick={() => { handleEdit(idx1, idx2) }}><EditOutlined fontSize="inherit" /></IconButton></Tooltip>
                        </>}
                    </ListItemButton>
                })}
                {/* <Divider sx={{color:"#fff"}}/> */}
            </Box>
        })}
        {rightDrawer && <RightDrawer toggleDrawer={handleRightDrawer} open={rightDrawer ? true : false}>
            {rightDrawer}
        </RightDrawer>}
    </Box>

}

export default ClassList